import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPills } from '@fortawesome/free-solid-svg-icons'
import '../Styling/MobileMedications.css'
import usePatChronicMeds from '../../hooks/usePatChronicMeds'
import { requestMedicationRefill } from '../../api/medicationsApi'
import { message } from 'antd'

const MobChronicMedicationsCarousel = () => {
  const { activeIndex, chronicMeds, listRef, handleScroll } = usePatChronicMeds()
  const [requestingRefill, setRequestingRefill] = useState(false)

  const formatMedicationName = (name) => {
    if (!name) return ''
    return name
      .split(' ')
      .map((word) =>
        word.length <= 2 ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ')
  }

  const handleRequestRefill = async (medicationId, event) => {
    event.preventDefault()
    event.stopPropagation()

    try {
      setRequestingRefill(true)
      await requestMedicationRefill(medicationId)
      message.success('Refill request submitted successfully')
    } catch (error) {
      message.error('Failed to request refill. Please try again later.')
    } finally {
      setRequestingRefill(false)
    }
  }

  return (
    <div>
      <div className='chronic-meds-container'>
        <div className='mobile-chronic-meds'>
          <div className='chronic-meds-list' ref={listRef} onScroll={handleScroll}>
            {chronicMeds.map((med, index) => (
              <div key={index} className={`med-card ${index === activeIndex ? 'active' : ''}`}>
                <div className='med-icon'>
                  <FontAwesomeIcon icon={faPills} />
                </div>
                <div className='med-info'>
                  <div className='med-header'>
                    <h3>{formatMedicationName(med.med.name)}</h3>
                    <span className='dosage'>{`${med.med.strengthMetric1} ${med.med.unitOfMeasure1}`}</span>
                  </div>
                  <p className='frequency'>{med.med.scriptingDosage || 'As prescribed'}</p>
                  <div className='refill-info'>
                    <div className='days-left'>
                      <div className='label'>Standard Pack Size:</div>
                      <span className='value'>{med.med.standardPacksize}</span>
                    </div>
                    <button
                      className='request-btn'
                      onClick={(e) => handleRequestRefill(med.med.id, e)}
                      disabled={requestingRefill}
                    >
                      {requestingRefill ? 'Requesting...' : 'Request Refill'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
            {chronicMeds.length === 0 && (
              <div className='empty-med-card'>
                <FontAwesomeIcon icon={faPills} size='2x' />
                <p>No chronic medications found</p>
                <p className='empty-subtitle'>Your chronic medications will appear here</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobChronicMedicationsCarousel
